var _circle, _line, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 9,
    r: 9,
    transform: "rotate(-90 9 9)",
    fill: "#F9F9F9"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 14.8177,
    y1: 8.98715,
    x2: 4.98195,
    y2: 8.98715,
    stroke: "#4D515F",
    strokeWidth: 0.964286,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.73077 12.2355L4.5 9.0047L7.73077 5.77393",
    stroke: "#4D515F",
    strokeWidth: 0.964286,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBack);
export default __webpack_public_path__ + "static/media/Back.4c5185080326d9853ab2058371d8f5d4.svg";
export { ForwardRef as ReactComponent };